import { StyledTag } from './StatusTagStyles';
import { UserStatus } from '@/models/users.model';
import { useTranslation } from 'react-i18next';

type ITagProps = {
  status?: UserStatus;
};

const StatusTag = ({ status }: ITagProps) => {
  const { t } = useTranslation(['common']);

  return <StyledTag $status={status}>{t(`user_statuses_${status}`)}</StyledTag>;
};

export default StatusTag;
